



import { Component, Mixins } from 'vue-property-decorator'
import Explanation from '@/components/organisms/study/Explanation.vue'
import Contents4 from '@/views/student/study/Contents4.vue'

@Component({
  components: {
    Explanation,
  },
})
export default class Explanation8 extends Mixins(Contents4) {}
